import { render, staticRenderFns } from "./BubuiaMap.vue?vue&type=template&id=4cfb8fb6&scoped=true&"
import script from "./BubuiaMap.vue?vue&type=script&lang=js&"
export * from "./BubuiaMap.vue?vue&type=script&lang=js&"
import style0 from "./BubuiaMap.vue?vue&type=style&index=0&id=4cfb8fb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfb8fb6",
  null
  
)

export default component.exports